<template>
  <div>
    <Breadtabsheader/>
    <div class="h-piece w-piece">
      <div class="h-pieceTitle2">
        <h1>返利测算</h1>
      </div>
      <div class="h-pieceCon2">
        <div class="h-formLine message">
          <el-form :model="fl" label-position="right" ref="formLabelAlign" :inline="true"
                   class="demo-ruleForm h-formbLine">
            <el-form-item prop="areaCode" label="区域" class="h-elformWrap-2">
              <brselect category="YLRegion" :v="fl.areaCode" v-model="fl.areaCode"/>
            </el-form-item>
            <el-form-item label="客户" class="h-elformWrap-2" prop="customerName">
              <el-select
                  v-model="fl.customerName"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入经销商名称"
                  :remote-method="getCustomerPage"
                  :loading="loading"
                  @change="selectResult">
                <el-option
                    v-for="item in agentList"
                    :key="item.agentCode"
                    :label="item.agentName"
                    :value="item.agentName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="field" label="链群" class="h-elformWrap-2">
              <el-select v-model="fl.field" style="width: 100%" @change="handleFieldChange">
                <el-option v-for="item in fieldOptions" :key="item.value" :value="item.value"
                           :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="测算周期" prop="radio" style="width: 50%;" class="h-elformWrap-2">
              <el-radio-group v-model="radio">
                <el-radio :label="1">月度返利</el-radio>
                <el-radio :label="2">季度返利</el-radio>
                <el-radio v-if="fl.field === 'cdwdwdgj'" :label="3">年度奖励</el-radio>
              </el-radio-group>
            </el-form-item>
            <br>
          </el-form>
          <div style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
            <div
                style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
                @click="shengcheng">测算
            </div>
          </div>
          <br>
        </div>
        <div v-if="noTarget"><span
            style="color: red;font-size: 13px">未查询到目标数据，请检查区域、经销商名称、领域是否正确</span></div>
        <div class="h-table h-mrt30 " style="margin: 5px 0 0 5px;">
          <div v-if="cs_yue">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;">
                <td style="width: 80px" class="h-head">周期</td>
                <td style="width: 150px" class="h-head">条件</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">完成率</td>
                <td style="width: 200px" class="h-head" v-if="cs_yue_fl">返利预测金额（含税）</td>
                <td style="width: 450px;" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan="1" class="h-head">{{ month.month1 }}</td>
                <td style="width: 100px" class="h-text">{{ monthConditionText }}</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month1Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month1Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month1Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{ month1Lvyue }}</td>
                <td style="width: 100px" class="h-result" v-if="cs_yue_fl">{{ month.month1Rebate }}</td>
                <td style="width: 100px" rowspan="3" class="remark">
                  1.该返利测算规则只适用于签约协议为一级经销商的客户，其他类型不适用。<br/>
                  2.填写正确的公司名称并选择领域后，自带出目标、销额，目标不可更改，销额、基数可进行调整，点击测算按钮进行测算。<br/>
                  3.该返利测算金额仅为预测金额，最终实际返利金额以财务测算为准。<br/>
                  4.仅供测算参考，最终解释权归青岛海尔生物医疗设备有限公司。<br/>
                  5、目标、实际、返利基数均为含税金额<br/>(单位：万元)<br/>
                  6、实际金额为OMS系统中销售样表<br/>【是否计入销额】字段“是”<br/>
                  7、返利基数为OMS系统中销售样表<br/>【是否计入基数】字段“是”<br/>
<!--                  8、分销商运营费为签约三方协议的客户<br/>在OMS系统下单金额*5%-->
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan="1" class="h-head">{{ month.month2 }}</td>
                <td style="width: 100px" class="h-text">{{ monthConditionText }}</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month2Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month2Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month2Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{ month2Lvyue }}</td>
                <td style="width: 100px" class="h-result" v-if="cs_yue_fl">{{ month.month2Rebate }}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan="1" class="h-head">{{ month.month3 }}</td>
                <td style="width: 100px" class="h-text">{{ monthConditionText }}</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month3Goal" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month3Sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month3Base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{ month3Lvyue }}</td>
                <td style="width: 100px" class="h-result" v-if="cs_yue_fl">{{ month.month3Rebate }}</td>
              </tr>
            </table>
          </div>
          <div v-if="cs_jidu">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <template v-for="(type, typeIndex) in quarterlyTypeConfigs">
              <tr v-for="(stage, stageIndex) in type.stages"
                  :key="type.key + '_' + stageIndex"
                  style="background-color: White; text-align: center; color:black;height:30px;">
                <td v-if="typeIndex === 0 && stageIndex === 0"
                    :rowspan="quarterlyTotalRows"
                    style="width: 80px"
                    class="h-text">
                  季度
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 120px"
                    class="h-text">
                  {{ type.label }}
                </td>
                <td style="width: 210px" class="h-text">{{ stage.condition }}</td>
                <td style="width: 90px" class="h-text">{{ stage.rate }}</td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 80px"
                    class="h-text">
                  <span v-if="type.key === 'base'">{{ jidu.jichuXishuLv }}</span>
                  <span v-else>/</span>
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 100px"
                    class="h-count">
                  <el-input v-if="type.key === 'base'" v-model="jidu.goal" readonly/>
                  <span v-else>/</span>
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 100px"
                    class="h-edit">
                  <el-input v-if="type.key === 'base'" v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                  <span v-else>/</span>
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 100px"
                    class="h-edit">
                  <el-input v-if="type.key === 'base'" v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                  <span v-else>/</span>
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 100px"
                    class="h-text">
                  <span v-if="type.key === 'base'">{{ jiduLvyue_ct }}</span>
                  <span v-else>/</span>
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 150px"
                    class="h-result">
                  {{ getQuarterlyTypeAmount(type.key) }}
                </td>
                <td v-if="stageIndex === 0"
                    :rowspan="type.stages.length"
                    style="width: 400px; text-align: left"
                    class="remark">
                  <span v-if="type.key === 'base'">季度返利：季度累计履约率100%及以上；按当前目标台阶计算返利系数。</span>
                </td>
              </tr>
              </template>
              <template v-if="false">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">数智样本</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ybw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ybw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ybw }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ybw }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属数智样本产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<100</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">100≤X<180</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X<300</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">300≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">智慧医疗</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ypw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ypw" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ypw }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ypw }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧医疗产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<60</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">60≤X<120</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X<180</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">智慧血液</td>
                <td style="width: 100px" class="h-text">X<6</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_ND5" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_ND5" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_ND5 }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_ND5 }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧血液产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">6≤X<30</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">30≤X<90</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">90≤X<120</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="5" class="h-text">实验室设备</td>
                <td style="width: 100px" class="h-text">X<15</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.goal_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.sales_swaq" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base_swaq" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-text">{{ jiduLvyue_swaq }}</td>
                <td style="width: 150px" rowspan="5" class="h-result">{{ jidu.rebate_swaq }}</td>
                <td style="width: 400px" rowspan="5" class="remark">①每季度签约销售额符合实验室设备产业的奖励台阶<br/>②归属实验室设备产业的销售额完成率≥100%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">15≤X<50</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">50≤X<90</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">90≤X<120</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X</td>
                <td style="width: 100px" class="h-text">5%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan="4" class="h-text">传统整体</td>
                <td style="width: 100px" class="h-text">X<35</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan="5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv" readonly/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-count">
                  <el-input v-model="jidu.goal" readonly/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="5" class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan="4" class="h-text">{{ jiduLvyue_ct }}</td>
                <td style="width: 150px" rowspan="4" class="h-result">{{ jidu.rebate }}</td>
                <td style="width: 400px" rowspan="4" class="remark">①季度整体目标完成率100%及以上<br/>②季度内每月完成率均不低于70%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">35≤X<210</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">210≤X<410</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">410≤X</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              </template>
            </table>
          </div>
          <div v-if="cs_jidu && (chosenField || fl.field) === 'cdwdwdgj'">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">季度同期</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">季度</td>
                <td class="h-text">超同期奖励</td>
                <td class="h-text">签约目标&gt;同期且实际完成&gt;同期且完成率≥80%</td>
                <td class="h-text">单台阶</td>
                <td class="h-text">2%</td>
                <td class="h-count"><el-input v-model="jidu.tongqi" readonly/></td>
                <td class="h-count"><el-input v-model="jidu.goal" readonly/></td>
                <td class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ jiduLvyue_ct }}</td>
                <td class="h-result">{{ jidu.rebateSuperSamePeriod }}</td>
                <td class="remark">超同期奖励：签约目标&gt;同期且实际完成&gt;同期且完成率≥80%，返利系数2%。</td>
              </tr>
            </table>
          </div>
          <div v-if="cs_jidu && (chosenField || fl.field) === 'zhyl'">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">用户等级</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr v-for="(stage, index) in levelAccelerateStages"
                  :key="'level_acc_stage_' + index"
                  style="background-color: White; text-align: center; color:black;height:30px;">
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">季度</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">等级加速奖励</td>
                <td class="h-text">{{ stage.condition }}</td>
                <td class="h-text">{{ stage.rate }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">{{ getLevelAccelerateRateText() }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-count"><el-input :value="agentLevelText()" readonly/></td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-count"><el-input v-model="jidu.goal" readonly/></td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-text">{{ jiduLvyue_ct }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="h-result">{{ jidu.rebateLevelAccelerate }}</td>
                <td v-if="index === 0" :rowspan="levelAccelerateStages.length" class="remark">
                  等级加速奖励：A类客户 季度实际基数*4%；B类客户 季度实际基数*3%；C类客户 季度实际基数*1%；新开客户 季度实际基数*3%。
                </td>
              </tr>
            </table>
          </div>
          <div v-if="cs_year">
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" class="h-head">季度</td>
                <td style="width: 120px" class="h-head">返利类型</td>
                <td style="width: 210px" class="h-head">台阶条件</td>
                <td style="width: 90px" class="h-head">台阶系数</td>
                <td style="width: 100px" class="h-head">季度</td>
                <td style="width: 90px" class="h-head">实际系数</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 120px" class="h-head">返利基数</td>
                <td style="width: 150px" class="h-head">季度通算金额<br/>（含税）</td>
              </tr>
              <tr v-for="(row, idx) in annualQuarterRows"
                  :key="'year_q_' + idx"
                  style="background-color: White; text-align: center; color:black;height:30px;">
                <td v-if="idx === 0" :rowspan="annualQuarterRows.length" class="h-text">季度</td>
                <td v-if="idx === 0" :rowspan="annualQuarterRows.length" class="h-text">季度返利</td>
                <td v-if="idx === 0" :rowspan="annualQuarterRows.length" class="h-text" style="white-space: pre-line;">{{ cdwdStageConditionText }}</td>
                <td v-if="idx === 0" :rowspan="annualQuarterRows.length" class="h-text" style="white-space: pre-line;">{{ cdwdStageRateText }}</td>
                <td class="h-text">{{ row.quarter }}</td>
                <td class="h-text">{{ row.actualRateText }}</td>
                <td class="h-text">{{ row.goal }}</td>
                <td class="h-edit">
                  <el-input v-model="annualQuarter[row.baseKey]" maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-result">{{ row.rebate }}</td>
              </tr>
            </table>
            <table
                style="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;"
                cellspacing=0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 120px" class="h-head">周期</td>
                <td style="width: 280px" class="h-head">条件</td>
                <td style="width: 140px" class="h-head">年度目标</td>
                <td style="width: 140px" class="h-head">年度实际</td>
                <td style="width: 140px" class="h-head">年度履约率</td>
                <td style="width: 180px" class="h-head">通算金额</td>
                <td style="width: 180px" class="h-head">已得奖励</td>
                <td style="width: 220px" class="h-head">返利金额</td>
                <td style="width: 500px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td class="h-text">年度通算</td>
                <td class="h-text">年度履约大于等于100%</td>
                <td class="h-text">{{ annualGoalTotal }}</td>
                <td class="h-edit">
                  <el-input v-model="annual.actualAmount"
                            maxlength="12"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td class="h-text">{{ annualLvyueRateText }}</td>
                <td class="h-result">{{ annualComputedTotalAmount }}</td>
                <td class="h-edit">
                  <el-input v-model="annual.obtainedReward" readonly/>
                </td>
                <td class="h-result">{{ annualRebateAmount }}</td>
                <td class="remark">
                  1-12月累计计入基数销售额*3%+Q1实际计入基数销售额*Q1签约目标所在奖励台阶的对应系数+Q2实际计入基数销售额* Q2签约目标所在奖励台阶的对应系数+ Q3实际计入基数销售额* Q3签约目标所在奖励台阶的对应系数+ Q4实际计入基数销售额* Q4签约目标所在奖励台阶的对应系数-全年内已得奖励
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div style="text-align: center" v-if="fl_cesuan">
          <br/>
          <el-button class="h-btn h-bBtn h-bggreen" @click="flRebateCalculate()">返利测算</el-button>
          <br/>
          <br/>
          <br/>
        </div>
        <div class="yx_progressBar" v-if="result_jidu || result_month || result_year">
          <div class="yx_topTip">
            <div class="leftdes" v-if="result_month">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>月度返利：</span>
                </el-col>
                <el-col :span="4">
                  <span>{{ month.month1 }}：{{ month.month1RebateHj }}</span>
                </el-col>
                <el-col :span="4">
                  <span>{{ month.month2 }}：{{ month.month2RebateHj }}</span>
                </el-col>
                <el-col :span="4">
                  <span>{{ month.month3 }}：{{ month.month3RebateHj }}</span>
                </el-col>
                <el-col :span="9"></el-col>
              </el-row>
            </div>
            <br/>
            <div class="leftdes" v-if="result_jidu">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>季度奖励：</span>
                </el-col>
                <el-col :span="2">
                  {{ jidu.rebateBaseTotal }}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
              <el-row v-if="(chosenField || fl.field) === 'cdwdwdgj'" type="flex" style="flex-wrap: wrap;width:100%;margin-top: 0.08rem;">
                <el-col :span="3">
                  <span>超同期奖励：</span>
                </el-col>
                <el-col :span="2">
                  {{ jidu.rebateSuperSamePeriod }}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
              <el-row v-if="(chosenField || fl.field) === 'zhyl'" type="flex" style="flex-wrap: wrap;width:100%;margin-top: 0.08rem;">
                <el-col :span="3">
                  <span>等级加速奖励：</span>
                </el-col>
                <el-col :span="2">
                  {{ jidu.rebateLevelAccelerate }}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
            </div>
            <div class="leftdes" v-if="result_year">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>年度奖励：</span>
                </el-col>
                <el-col :span="4">
                  {{ annualRebateAmount }}
                </el-col>
                <el-col :span="17"></el-col>
              </el-row>
            </div>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import nc from '../../../utils/numberCalc';
import ss from '../../../api/SystemService';

export default {
  components: {},
  data() {
    return {
      loading: false,
      cs_yue: false,
      cs_jidu: false,
      cs_year: false,
      cs_yue_fl: false,
      fl_cesuan: false,
      result_month: false,
      result_jidu: false,
      result_year: false,
      result_all: false,
      radio: 1,
      chooseRadio: 1,
      isReadOnly: false,
      noTarget: false,
      // 本次“测算”生效的链群快照；只有点击“测算”后才更新，用于驱动表格显示与计算
      chosenField: null,
      fieldOptions: [ // 下拉菜单的选项
        {value: 'zhyl', label: '药品网'},
        {value: 'szky', label: '离心机&培养箱&生物安全'},
        {value: 'cdwdwdgj', label: '超低温&低温&冻干机'},
        {value: 'ND4', label: '疫苗网'}
      ],
      agentList: [],
      state: false,
      fl: {
        customerName: null,
        field: null,
        areaCode: null,
      },
      month: {
        month1: null,
        month2: null,
        month3: null,
        monthXishu: 0.03,
        monthXishuFx: 0.05,
        month1Goal: 0,
        month2Goal: 0,
        month3Goal: 0,
        month1Sales: null,
        month2Sales: null,
        month3Sales: null,
        month1Base: null,
        month2Base: null,
        month3Base: null,
        month1Lvyue: 0.00,
        month2Lvyue: 0.00,
        month3Lvyue: 0.00,
        month1Rebate: 0.00,
        month2Rebate: 0.00,
        month3Rebate: 0.00,
        month1BaseFx: 0.00,
        month2BaseFx: 0.00,
        month3BaseFx: 0.00,
        month1RebateFx: 0.00,
        month2RebateFx: 0.00,
        month3RebateFx: 0.00,
        month1BaseHj: 0,
        month2BaseHj: 0,
        month3BaseHj: 0,
        month1LvyueHj: 0.00,
        month2LvyueHj: 0.00,
        month3LvyueHj: 0.00,
        month1RebateHj: 0.00,
        month2RebateHj: 0.00,
        month3RebateHj: 0.00,
      },
      jidu: {
        jichuXishu: 0,
        jichuXishu_ybw: 0,
        jichuXishu_ypw: 0,
        jichuXishu_swaq: 0,
        jichuXishu_ND5: 0,
        jichuXishuLv: '0%',
        jichuXishuLv_ybw: '0%',
        jichuXishuLv_ypw: '0%',
        jichuXishuLv_swaq: '0%',
        jichuXishuLv_ND5: '0%',
        sales_ybw: null,
        base_ybw: null,
        sales_ypw: null,
        base_ypw: null,
        sales_swaq: null,
        base_swaq: null,
        sales_ND5: null,
        base_ND5: null,
        sales: 0,
        base: 0,
        goal: 0,
        goal_ybw: 0,
        goal_ypw: 0,
        goal_swaq: 0,
        goal_ND5: 0,
        lvyue_ybw: 0,
        lvyue_ypw: 0,
        lvyue_swaq: 0,
        lvyue_ND5: 0,
        lvyue: 0,
        lvyueLv_ybw: null,
        lvyueLv_ypw: null,
        lvyueLv_swaq: null,
        lvyueLv_ND5: null,
        rebate: 0,
        rebate_ybw: 0,
        rebate_ypw: 0,
        rebate_swaq: 0,
        rebate_ND5: 0,
        // 基础季度返利（不含新增奖励类型）
        rebateBaseTotal: 0,
        // 超同期奖励金额
        rebateSuperSamePeriod: 0,
        // 等级加速奖励金额
        rebateLevelAccelerate: 0,
        // 辅助判定字段（可由后端返回，暂无时默认0）
        tongqi: 0,
        agentLevel: 3,
        samePeriodGoal: 0,
        samePeriodSales: 0,
        sales2025: 0,
        sales2024: 0,
        isNewCustomer: 0,
        jiduRebate: 0,
      },
      annual: {
        // 后端接口预留字段（接口未开发前先占位）
        totalAmount: 0,
        obtainedReward: 0,
        actualAmount: 0
      },
      // 年度页使用：后端 type=Y 返回的季度目标/基数
      annualQuarter: {
        goalQ1: 0,
        goalQ2: 0,
        goalQ3: 0,
        goalQ4: 0,
        baseQ1: 0,
        baseQ2: 0,
        baseQ3: 0,
        baseQ4: 0
      },
      areaName: sessionStorage.getItem("areaName") || ''
    }
  },
  created() {
    this.setMonthTitle();
    this.localAgent();
  },
  computed: {
    annualRebateAmount() {
      if (this.annualLvyueRateNum < 1) return 0;
      return nc.sub(this.annualComputedTotalAmount || 0, this.annual.obtainedReward || 0);
    },
    annualComputedTotalAmount() {
      if (this.annualLvyueRateNum < 1) return 0;
      // 通算金额 = 四季度返利基数和 *3% + 四季度通算金额和
      return nc.add(
        nc.mul(this.annualQuarterBaseSum, 0.03),
        this.annualQuarterRebateSum
      );
    },
    annualGoalTotal() {
      return nc.add(
        Number(this.annualQuarter.goalQ1 || 0),
        Number(this.annualQuarter.goalQ2 || 0),
        Number(this.annualQuarter.goalQ3 || 0),
        Number(this.annualQuarter.goalQ4 || 0)
      );
    },
    annualLvyueRateNum() {
      const target = Number(this.annualGoalTotal || 0);
      const actual = Number(this.annual.actualAmount || 0);
      if (target <= 0) return 0;
      return Number(nc.div(actual, target));
    },
    annualLvyueRateText() {
      return nc.mul(this.annualLvyueRateNum, 100).toFixed(2) + '%';
    },
    annualQuarterBaseSum() {
      return nc.add(
        Number(this.annualQuarter.baseQ1 || 0),
        Number(this.annualQuarter.baseQ2 || 0),
        Number(this.annualQuarter.baseQ3 || 0),
        Number(this.annualQuarter.baseQ4 || 0)
      );
    },
    annualQuarterRebateSum() {
      return this.annualQuarterRows.reduce((sum, row) => nc.add(sum, Number(row.rebate || 0)), 0);
    },
    rebateTypes() {
      const effectiveField = this.chosenField || this.fl.field;
      const selected = this.fieldOptions.find(item => item.value === effectiveField);
      const baseLabel = selected ? selected.label : '返利类型';
      const types = [{key: 'base', label: baseLabel}];
      if (effectiveField === 'cdwdwdgj') {
        types.push({key: 'superSamePeriod', label: '超同期奖励'});
      }
      if (effectiveField === 'zhyl') {
        types.push({key: 'levelAccelerate', label: '等级加速奖励'});
      }
      return types;
    },
    quarterlyTypeConfigs() {
      const effectiveField = this.chosenField || this.fl.field;
      const selected = this.fieldOptions.find(item => item.value === effectiveField);
      const baseLabel = selected ? selected.label : '返利类型';
      const baseStagesByField = {
        // 超低温&低温&冻干机
        cdwdwdgj: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<100', rate: '1%'},
          {condition: '100≤X<180', rate: '3%'},
          {condition: '180≤X<300', rate: '4%'},
          {condition: '300≤X', rate: '5%'}
        ],
        // 疫苗网
        ND4: [
          {condition: 'X<10', rate: '0%'},
          {condition: '10≤X<30', rate: '2%'},
          {condition: '30≤X<50', rate: '3%'},
          {condition: '50≤X<100', rate: '5%'},
          {condition: '100≤X', rate: '6%'}
        ],
        // 药品网
        zhyl: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ],
        // 离心机&培养箱&生物安全
        szky: [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ]
      };

      const configs = [{
        key: 'base',
        label: baseLabel,
        stages: baseStagesByField[effectiveField] || [
          {condition: 'X<20', rate: '0%'},
          {condition: '20≤X<45', rate: '4%'},
          {condition: '45≤X<60', rate: '5%'},
          {condition: '60≤X<100', rate: '6%'},
          {condition: '100≤X', rate: '7%'}
        ]
      }];

      return configs;
    },
    quarterlyTotalRows() {
      return this.quarterlyTypeConfigs.reduce((sum, item) => sum + item.stages.length, 0);
    },
    levelAccelerateStages() {
      return [
        {condition: 'A类客户：签约≥56.5万，26年签约目标＞25年实际销额＞24年实际销额', rate: '季度实际基数*4%'},
        {condition: 'B类客户：签约≥56.5万，26年签约目标＞25年实际销额', rate: '季度实际基数*3%'},
        {condition: 'C类客户：签约<56.5万', rate: '季度实际基数*1%'},
        {condition: '新开客户：26年新开合作网络', rate: '季度实际基数*3%'}
      ];
    },
    annualQuarterRows() {
      const rows = [
        {quarter: 'Q1', goal: Number(this.annualQuarter.goalQ1 || 0), base: Number(this.annualQuarter.baseQ1 || 0)},
        {quarter: 'Q2', goal: Number(this.annualQuarter.goalQ2 || 0), base: Number(this.annualQuarter.baseQ2 || 0)},
        {quarter: 'Q3', goal: Number(this.annualQuarter.goalQ3 || 0), base: Number(this.annualQuarter.baseQ3 || 0)},
        {quarter: 'Q4', goal: Number(this.annualQuarter.goalQ4 || 0), base: Number(this.annualQuarter.baseQ4 || 0)}
      ];
      return rows.map(r => {
        const rateNum = this.getQuarterlyBaseRateByField('cdwdwdgj', r.goal);
        return {
          ...r,
          baseKey: `base${r.quarter}`,
          actualRateText: nc.mul(rateNum, 100) + '%',
          rebate: nc.mul(r.base, rateNum)
        };
      });
    },
    cdwdStageConditionText() {
      return 'X<20\n20≤X<100\n100≤X<180\n180≤X<300\n300≤X';
    },
    cdwdStageRateText() {
      return '0%\n1%\n3%\n4%\n5%';
    },
    monthConditionText() {
      // 根据本次“测算”生效的链群切换月度条件文案
      const effectiveField = this.chosenField || this.fl.field;
      // 超低温
      if (effectiveField === 'cdwdwdgj') {
        return '签约目标≥10万且完成率≥100%';
      }
      // 药品网
      if (effectiveField === 'zhyl') {
        return '月度完成率≥100%';
      }
      // 疫苗网
      if (effectiveField === 'ND4') {
        return '签约目标≥6万且完成率≥100%';
      }
      // 离心机、培养箱、生物安全
      if (effectiveField === 'szky') {
        return '签约目标≥8万且完成率≥100%';
      }
      // 默认保留原始条件
      return '目标≥15万且完成率≥100%';
    },
    /*月度返利计算*/
    //履约率 = 销额/目标
    month1Lvyue: function () {
      if (this.month.month1Goal && this.month.month1Sales) {
        if (this.month.month1Goal > 0 && this.month.month1Sales > 0) {
          this.month.month1Lvyue = nc.div(this.month.month1Sales, this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month2Lvyue: function () {
      if (this.month.month2Goal && this.month.month2Sales) {
        if (this.month.month2Goal > 0 && this.month.month2Sales > 0) {
          this.month.month2Lvyue = nc.div(this.month.month2Sales, this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month3Lvyue: function () {
      if (this.month.month3Goal && this.month.month3Sales) {
        if (this.month.month3Goal > 0 && this.month.month3Sales > 0) {
          this.month.month3Lvyue = nc.div(this.month.month3Sales, this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3Lvyue);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    //基数合计
    month1BaseHj: function () {
      if (this.month.month1Base) {
        this.month.month1BaseHj = nc.add(this.month.month1Base, this.month.month1BaseFx);
        return this.month.month1BaseHj;
      } else {
        return null;
      }
    },
    month2BaseHj: function () {
      if (this.month.month2Base) {
        this.month.month2BaseHj = nc.add(this.month.month2Base, this.month.month2BaseFx);
        return this.month.month2BaseHj;
      } else {
        return null;
      }
    },
    month3BaseHj: function () {
      if (this.month.month3Base) {
        this.month.month3BaseHj = nc.add(this.month.month3Base, this.month.month3BaseFx);
        return this.month.month3BaseHj;
      } else {
        return null;
      }
    },
    //合计履约率
    month1LvyueHj: function () {
      if (this.month.month1Goal && this.month.month1Sales) {
        if (this.month.month1Goal > 0 && this.month.month1Sales > 0) {
          this.month.month1LvyueHj = nc.div(this.month.month1Sales, this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month2LvyueHj: function () {
      if (this.month.month2Goal && this.month.month2Sales) {
        if (this.month.month2Goal > 0 && this.month.month2Sales > 0) {
          this.month.month2LvyueHj = nc.div(this.month.month2Sales, this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    month3LvyueHj: function () {
      if (this.month.month3Goal && this.month.month3Sales) {
        if (this.month.month3Goal > 0 && this.month.month3Sales > 0) {
          this.month.month3LvyueHj = nc.div(this.month.month3Sales, this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3LvyueHj);
        } else {
          return '0.00%';
        }
      } else {
        return null;
      }
      ;
    },
    /*季度返利计算*/
    //季度基数
    jiduBase: function () {
      this.jidu.base = nc.add(this.jidu.base_ybw, this.jidu.base_ypw, this.jidu.base_swaq, this.jidu.base_ND5);
      return this.jidu.base;
    },
    //季度履约率
    jiduLvyue_ybw: function () {
      this.jidu.lvyue_ybw = this.jidu.goal_ybw > 0 ? nc.div(this.jidu.sales_ybw, this.jidu.goal_ybw).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ybw);
    },
    jiduLvyue_ypw: function () {
      this.jidu.lvyue_ypw = this.jidu.goal_ypw > 0 ? nc.div(this.jidu.sales_ypw, this.jidu.goal_ypw).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ypw);
    },
    jiduLvyue_swaq: function () {
      this.jidu.lvyue_swaq = this.jidu.goal_swaq > 0 ? nc.div(this.jidu.sales_swaq, this.jidu.goal_swaq).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_swaq);
    },
    jiduLvyue_ND5: function () {
      this.jidu.lvyue_ND5 = this.jidu.goal_ND5 > 0 ? nc.div(this.jidu.sales_ND5, this.jidu.goal_ND5).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue_ND5);
    },
    jiduLvyue_ct: function () {
      this.jidu.lvyue = this.jidu.goal > 0 ? nc.div(this.jidu.sales, this.jidu.goal).toFixed(4) : 0;
      return this.getLvyueLv(this.jidu.lvyue);
    },
  },
  methods: {
    // changeArea(obj){
    //   if(obj){
    //     sessionStorage.removeItem('areaName')
    //   }
    // },
    setResultFalse() {
      this.result_month = false;
      this.result_jidu = false;
      this.result_year = false;
    },
    handleFieldChange() {
      // 年度奖励仅支持“超低温&低温&冻干机”
      if (this.fl.field !== 'cdwdwdgj' && this.radio === 3) {
        this.radio = 2;
      }
    },
    /**
     * 按当前链群「季度台阶」配置，由季度签约目标(万元)取基础返利系数（与 quarterlyTypeConfigs 一致）
     */
    getQuarterlyBaseRateByField(field, goalVal) {
      // 优先使用本次测算锁定的链群
      const effectiveField = this.chosenField || field;
      const g = Number(goalVal) || 0;
      if (effectiveField === 'cdwdwdgj') {
        if (g < 20) return 0;
        if (g < 100) return 0.01;
        if (g < 180) return 0.03;
        if (g < 300) return 0.04;
        return 0.05;
      }
      if (effectiveField === 'ND4') {
        if (g < 10) return 0;
        if (g < 30) return 0.02;
        if (g < 50) return 0.03;
        if (g < 100) return 0.05;
        return 0.06;
      }
      if (effectiveField === 'zhyl' || effectiveField === 'szky') {
        if (g < 20) return 0;
        if (g < 45) return 0.04;
        if (g < 60) return 0.05;
        if (g < 100) return 0.06;
        return 0.07;
      }
      return this.getJiduJichuXishu(g, 'ct') || 0;
    },
    getCdwdStageConditionText(goalVal) {
      const g = Number(goalVal) || 0;
      if (g < 20) return 'X<20';
      if (g < 100) return '20≤X<100';
      if (g < 180) return '100≤X<180';
      if (g < 300) return '180≤X<300';
      return '300≤X';
    },
    //季度基础系数
    getJiduJichuXishu(goal, cy) {
      if ('ct' == cy) {
        if (goal >= 410) {
          return 0.03;
        } else if (goal >= 210) {
          return 0.02;
        } else if (goal >= 35) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('szyb' == cy) {
        if (goal >= 300) {
          return 0.04;
        } else if (goal >= 180) {
          return 0.03;
        } else if (goal >= 100) {
          return 0.02;
        } else if (goal >= 20) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('zhyl' == cy) {
        if (goal >= 180) {
          return 0.04;
        } else if (goal >= 120) {
          return 0.03;
        } else if (goal >= 60) {
          return 0.02;
        } else if (goal >= 20) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('zhxy' == cy) {
        if (goal >= 120) {
          return 0.04;
        } else if (goal >= 90) {
          return 0.03;
        } else if (goal >= 30) {
          return 0.02;
        } else if (goal >= 6) {
          return 0.01;
        } else {
          return 0;
        }
      } else if ('syssb' == cy) {
        if (goal >= 120) {
          return 0.05;
        } else if (goal >= 90) {
          return 0.04;
        } else if (goal >= 50) {
          return 0.03;
        } else if (goal >= 15) {
          return 0.02;
        } else {
          return 0;
        }
      }
    },
    //履约率%
    getLvyueLv(lvyue) {
      return nc.mul(lvyue, 100).toFixed(2) + '%';
    },
    getQuarterlyTypeAmount(typeKey) {
      if (typeKey === 'base') {
        return this.jidu.rebateBaseTotal;
      }
      if (typeKey === 'superSamePeriod') {
        return this.jidu.rebateSuperSamePeriod;
      }
      if (typeKey === 'levelAccelerate') {
        return this.jidu.rebateLevelAccelerate;
      }
      return 0;
    },
    getLevelAccelerateRateText() {
      const effectiveField = this.chosenField || this.fl.field;
      if (effectiveField !== 'zhyl') return '/';
      const level = Number(this.jidu.agentLevel);
      // 后端确认枚举：0=A，1=B，2=C，3=新开
      if (level === 0) return '4%';
      if (level === 1) return '3%';
      if (level === 2) return '1%';
      if (level === 3) return '3%';
      return '0%';
    },
    agentLevelText() {
      const level = Number(this.jidu.agentLevel);
      // 后端确认枚举：0=A，1=B，2=C，3=新开
      if (level === 0) return 'A级';
      if (level === 1) return 'B级';
      if (level === 2) return 'C级';
      if (level === 3) return '新开';
      return '/';
    },
    setMonthTitle() {
      //设置月份
      const date = new Date();
      const currentMonth = date.getMonth() + 1
      if (currentMonth == 1 || currentMonth == 4 || currentMonth == 7 || currentMonth == 10) {
        this.month.month1 = currentMonth + '月';
        this.month.month2 = (currentMonth + 1) + '月';
        this.month.month3 = (currentMonth + 2) + '月';
      } else if (currentMonth == 2 || currentMonth == 5 || currentMonth == 8 || currentMonth == 11) {
        this.month.month2 = currentMonth + '月';
        this.month.month3 = (currentMonth + 1) + '月';
        this.month.month1 = (currentMonth - 1) + '月';
      } else if (currentMonth == 3 || currentMonth == 6 || currentMonth == 9 || currentMonth == 12) {
        this.month.month3 = currentMonth + '月';
        this.month.month2 = (currentMonth - 1) + '月';
        this.month.month1 = (currentMonth - 2) + '月';
      }
    },
    selectFlInfoByAgent() {
      if (this.fl.customerName && this.fl.areaCode && this.fl.field) {
        this.setZero();
        this.noTarget = false;
        this.getTargetByCustomer();
        if (!this.noTarget) {
          this.getBaseByCustomer();
        }
      }
    },
    //销额基数设置0
    setZero() {
      this.setMonthZero();
      this.setJiduZero();
      this.setAnnualQuarterZero();
    },
    setAnnualQuarterZero() {
      this.annualQuarter.goalQ1 = 0;
      this.annualQuarter.goalQ2 = 0;
      this.annualQuarter.goalQ3 = 0;
      this.annualQuarter.goalQ4 = 0;
      this.annualQuarter.baseQ1 = 0;
      this.annualQuarter.baseQ2 = 0;
      this.annualQuarter.baseQ3 = 0;
      this.annualQuarter.baseQ4 = 0;
    },
    setMonthZero() {
      //月度
      this.month.month1Goal = 0;
      this.month.month2Goal = 0;
      this.month.month3Goal = 0;
      this.month.month1Sales = 0;
      this.month.month2Sales = 0;
      this.month.month3Sales = 0;
      this.month.month1Base = 0;
      this.month.month2Base = 0;
      this.month.month3Base = 0;
      this.month.month1BaseFx = 0;
      this.month.month2BaseFx = 0;
      this.month.month3BaseFx = 0;
      this.month.month1Rebate = 0;
      this.month.month2Rebate = 0;
      this.month.month3Rebate = 0;
      this.month.month1RebateHj = 0;
      this.month.month2RebateHj = 0;
      this.month.month3RebateHj = 0;
      this.month.month1RebateFx = 0;
      this.month.month2RebateFx = 0;
      this.month.month3RebateFx = 0;
    },
    setJiduZero() {
      //季度
      this.jidu.goal_ybw = 0;
      this.jidu.goal_ypw = 0;
      this.jidu.goal_swaq = 0;
      this.jidu.goal_ND5 = 0;
      this.jidu.goal = 0;
      this.jidu.sales_ybw = 0;
      this.jidu.sales_ypw = 0;
      this.jidu.sales_swaq = 0;
      this.jidu.sales_ND5 = 0;
      this.jidu.sales = 0;
      this.jidu.base_ybw = 0;
      this.jidu.base_ypw = 0;
      this.jidu.base_swaq = 0;
      this.jidu.base_ND5 = 0;
      this.jidu.base = 0;
      this.jidu.tongqi = 0;
      this.jidu.agentLevel = 3;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.rebateBaseTotal = 0;
      this.jidu.rebateSuperSamePeriod = 0;
      this.jidu.rebateLevelAccelerate = 0;
      this.jidu.jiduRebate = 0;
      this.annual.totalAmount = 0;
      this.annual.obtainedReward = 0;
      this.annual.actualAmount = 0;
    },
    //查询目标、销额
    getTargetByCustomer() {
      ss.fanli.getTargetByCustomer(this.fl.customerName, this.fl.areaCode, this.fl.field).then(rd => {
        if (rd.obj && rd.obj.length > 0) {
          console.log("查询目标：", rd.obj)
          this.isReadOnly = true;
          //初始化目标销额为0
          let quarterFromType1 = false;
          for (const element of rd.obj) {
            var goal = element;
            if (goal.type == '1') {
              this.month.month1Goal = goal.goal1;
              this.month.month2Goal = goal.goal2;
              this.month.month3Goal = goal.goal3;
              this.month.month1Sales = goal.sales1;
              this.month.month2Sales = goal.sales2;
              this.month.month3Sales = goal.sales3;
              this.jidu.tongqi = goal.tongqi == null || goal.tongqi === '' ? 0 : Number(goal.tongqi);
              this.jidu.agentLevel = goal.agentLevel == null || goal.agentLevel === '' ? 3 : Number(goal.agentLevel);
              // type=1：goal4=季度目标，sales4=季度实际
              this.jidu.goal = goal.goal4 == null || goal.goal4 === '' ? 0 : Number(goal.goal4);
              this.jidu.sales = goal.sales4 == null || goal.sales4 === '' ? 0 : Number(goal.sales4);
              quarterFromType1 = true;
              if (['cdwdwdgj', 'zhyl', 'ND4', 'szky'].includes(this.fl.field)) {
                this.jidu.jichuXishu = this.getQuarterlyBaseRateByField(this.fl.field, this.jidu.goal);
                this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
              }
            } else if (goal.type == '2') {
              if (goal.lianqun == 'szyb') {
                this.jidu.goal_ybw = goal.goal4;
                this.jidu.sales_ybw = goal.sales4;
                this.jidu.jichuXishu_ybw = this.getJiduJichuXishu(this.jidu.goal_ybw, goal.lianqun);
                this.jidu.jichuXishuLv_ybw = nc.mul(this.jidu.jichuXishu_ybw, 100) + '%';
              } else if (goal.lianqun == 'zhyl') {
                this.jidu.goal_ypw = goal.goal4;
                this.jidu.sales_ypw = goal.sales4;
                this.jidu.jichuXishu_ypw = this.getJiduJichuXishu(this.jidu.goal_ypw, goal.lianqun);
                this.jidu.jichuXishuLv_ypw = nc.mul(this.jidu.jichuXishu_ypw, 100) + '%';
              } else if (goal.lianqun == 'syssb') {
                this.jidu.goal_swaq = goal.goal4;
                this.jidu.sales_swaq = goal.sales4;
                this.jidu.jichuXishu_swaq = this.getJiduJichuXishu(this.jidu.goal_swaq, goal.lianqun);
                this.jidu.jichuXishuLv_swaq = nc.mul(this.jidu.jichuXishu_swaq, 100) + '%';
              } else if (goal.lianqun == 'zhxy') {
                this.jidu.goal_ND5 = goal.goal4;
                this.jidu.sales_ND5 = goal.sales4;
                this.jidu.jichuXishu_ND5 = this.getJiduJichuXishu(this.jidu.goal_ND5, goal.lianqun);
                this.jidu.jichuXishuLv_ND5 = nc.mul(this.jidu.jichuXishu_ND5, 100) + '%';
              }
              // 无 type=1 时：按拆行汇总季度目标/销额；已有 type=1 则以 goal4/sales4 为准，不再覆盖
              if (!quarterFromType1) {
                this.jidu.goal = nc.add(this.jidu.goal_ybw, this.jidu.goal_ypw, this.jidu.goal_swaq, this.jidu.goal_ND5);
                this.jidu.sales = nc.add(this.jidu.sales_ybw, this.jidu.sales_ypw, this.jidu.sales_swaq, this.jidu.sales_ND5);
                this.jidu.jichuXishu = this.getJiduJichuXishu(this.jidu.goal, 'ct');
                this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
              }
            }
          }
        } else {
          this.noTarget = true;
        }
      })
    },
    //查询基数
    getBaseByCustomer() {
      ss.fanli.getBaseByCustomer(this.fl.customerName, this.fl.areaCode, this.fl.field).then(rd => {
        if (rd.obj) {
          for (const element of rd.obj) {
            //月度
            if (element.type == '1') {
              if (element.agentType == 'yjjxs') {
                if (element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10') {
                  this.month.month1Base = element.base;
                } else if (element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11') {
                  this.month.month2Base = element.base;
                } else if (element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1') {
                  this.month.month3Base = element.base;
                }
              } else if (element.agentType == 'fxs') {
                if (element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10') {
                  this.month.month1BaseFx = element.base;
                } else if (element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11') {
                  this.month.month2BaseFx = element.base;
                } else if (element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1') {
                  this.month.month3BaseFx = element.base;
                }
              }
            } else if (element.type == '2') {
              if (element.lianqun == 'szyb') {
                this.jidu.base_ybw = element.base;
              } else if (element.lianqun == 'zhyl') {
                this.jidu.base_ypw = element.base;
              } else if (element.lianqun == 'syssb') {
                this.jidu.base_swaq = element.base;
              } else if (element.lianqun == 'zhxy') {
                this.jidu.base_ND5 = element.base;
              } else if (element.lianqun == 'ct') {
                this.jidu.base = element.base;
              }
            } else if (element.type == 'Y') {
              // 年度口径季度数据（从 getBaseByCustomer 返回中取 type=Y）
              this.annualQuarter.goalQ1 = Number(element.goal1 || 0);
              this.annualQuarter.goalQ2 = Number(element.goal2 || 0);
              this.annualQuarter.goalQ3 = Number(element.goal3 || 0);
              this.annualQuarter.goalQ4 = Number(element.goal4 || 0);
              this.annualQuarter.baseQ1 = Number(element.sales1 || 0);
              this.annualQuarter.baseQ2 = Number(element.sales2 || 0);
              this.annualQuarter.baseQ3 = Number(element.sales3 || 0);
              this.annualQuarter.baseQ4 = Number(element.sales4 || 0);
              this.annual.obtainedReward = Number(element.rebate || 0);
              this.annual.actualAmount = Number(element.tongqi || 0);
            }
          }
        }
      })
    },
    //返利测算
    flRebateCalculate() {
      this.setResultFalse();
      this.setRebateZero();
      //月度返利计算
      if (this.chooseRadio == 1) {
        this.monthRebate();
        this.result_month = true;
      } else if (this.chooseRadio == 2) {
        this.monthRebate();
        this.result_month = true;
        //季度返利计算
        this.jiduRebate();
        this.result_jidu = true;
      } else if (this.chooseRadio == 3) {
        this.annualRebateCalculate();
        this.result_year = true;
      }
      //日志
      this.rebateLog();
    },
    annualRebateCalculate() {
      // 年度通算金额改为实时计算（computed），这里仅保留占位，兼容原流程调用
      this.annual.obtainedReward = Number(this.annual.obtainedReward || 0);
    },
    monthRebate() {
      // 按当前页面实时输入的“目标 / 实际 / 基数 / 分销基数”重新计算三个月返利
      // 1. 不同链群的签约目标下限（按本次测算锁定的链群）
      const effectiveField = this.chosenField || this.fl.field;
      let goalMin = 15;
      if (effectiveField === 'cdwdwdgj') {          // 超低温&低温&冻干机
        goalMin = 10;
      } else if (effectiveField === 'zhyl') {       // 药品网：只看完成率
        goalMin = 0;
      } else if (effectiveField === 'ND4') {        // 疫苗网
        goalMin = 6;
      } else if (effectiveField === 'szky') {       // 离心机&培养箱&生物安全
        goalMin = 8;
      }

      const toNum = v => Number(v || 0);

      // === 第一个月 ===
      const g1 = toNum(this.month.month1Goal);
      const s1 = toNum(this.month.month1Sales);
      const b1 = toNum(this.month.month1Base);
      const b1Fx = toNum(this.month.month1BaseFx);
      const baseHj1 = nc.add(b1, b1Fx);
      const lvyue1 = g1 > 0 ? nc.div(s1, g1).toFixed(4) : 0;
      // 同步更新“合计基数 / 合计履约率”，保证表格展示和计算一致
      this.month.month1BaseHj = baseHj1;
      this.month.month1LvyueHj = lvyue1;
      if (g1 >= goalMin && lvyue1 >= 1) {
        this.month.month1Rebate = nc.mul(baseHj1, this.month.monthXishu);
      } else {
        this.month.month1Rebate = 0.00;
      }

      // === 第二个月 ===
      const g2 = toNum(this.month.month2Goal);
      const s2 = toNum(this.month.month2Sales);
      const b2 = toNum(this.month.month2Base);
      const b2Fx = toNum(this.month.month2BaseFx);
      const baseHj2 = nc.add(b2, b2Fx);
      const lvyue2 = g2 > 0 ? nc.div(s2, g2).toFixed(4) : 0;
      this.month.month2BaseHj = baseHj2;
      this.month.month2LvyueHj = lvyue2;
      if (g2 >= goalMin && lvyue2 >= 1) {
        this.month.month2Rebate = nc.mul(baseHj2, this.month.monthXishu);
      } else {
        this.month.month2Rebate = 0.00;
      }

      // === 第三个月 ===
      const g3 = toNum(this.month.month3Goal);
      const s3 = toNum(this.month.month3Sales);
      const b3 = toNum(this.month.month3Base);
      const b3Fx = toNum(this.month.month3BaseFx);
      const baseHj3 = nc.add(b3, b3Fx);
      const lvyue3 = g3 > 0 ? nc.div(s3, g3).toFixed(4) : 0;
      this.month.month3BaseHj = baseHj3;
      this.month.month3LvyueHj = lvyue3;
      if (g3 >= goalMin && lvyue3 >= 1) {
        this.month.month3Rebate = nc.mul(baseHj3, this.month.monthXishu);
      } else {
        this.month.month3Rebate = 0.00;
      }

      // 底部“月度返利”汇总展示
      this.month.month1RebateHj = this.month.month1Rebate;
      this.month.month2RebateHj = this.month.month2Rebate;
      this.month.month3RebateHj = this.month.month3Rebate;
    },
    jiduRebate() {
      const effectiveField = this.chosenField || this.fl.field;
      const unifiedChainFields = ['cdwdwdgj', 'zhyl', 'ND4', 'szky'];
      if (unifiedChainFields.includes(effectiveField)) {
        this.jidu.rebate_ybw = 0;
        this.jidu.rebate_ypw = 0;
        this.jidu.rebate_swaq = 0;
        this.jidu.rebate_ND5 = 0;
        this.jidu.rebate = 0;
        this.jidu.jichuXishu = this.getQuarterlyBaseRateByField(effectiveField, this.jidu.goal);
        this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu, 100) + '%';
        if (this.jidu.lvyue >= 1) {
          this.jidu.rebateBaseTotal = nc.mul(this.jidu.base, this.jidu.jichuXishu);
        } else {
          this.jidu.rebateBaseTotal = 0;
        }
      } else {
        //样本、智慧医疗、智慧血液需要整体100%以上，自身也100%以上，可计算返利
        if (this.jidu.lvyue >= 1) {
          //数智样本
          if (this.jidu.lvyue_ybw >= 1) {
            this.jidu.rebate_ybw = nc.mul(this.jidu.base_ybw, this.jidu.jichuXishu_ybw);
          }
          //智慧医疗
          if (this.jidu.lvyue_ypw >= 1) {
            this.jidu.rebate_ypw = nc.mul(this.jidu.base_ypw, this.jidu.jichuXishu_ypw);
          }
          //智慧血液
          if (this.jidu.lvyue_ND5 >= 1) {
            this.jidu.rebate_ND5 = nc.mul(this.jidu.base_ND5, this.jidu.jichuXishu_ND5);
          }
          //传统整体
          //判断每月完成率均不低于70%
          if (this.month.month1LvyueHj >= 0.7 && this.month.month2LvyueHj >= 0.7 && this.month.month3LvyueHj >= 0.7) {
            this.jidu.rebate = nc.mul(this.jidu.base, this.jidu.jichuXishu);
          } else {
            this.jidu.rebate = 0;
          }
        } else {
          this.jidu.rebate_ybw = 0;
          this.jidu.rebate_ypw = 0;
          this.jidu.rebate_ND5 = 0;
          this.jidu.rebate = 0;
        }
        //实验室设备
        if (this.jidu.lvyue_swaq >= 1) {
          this.jidu.rebate_swaq = nc.mul(this.jidu.base_swaq, this.jidu.jichuXishu_swaq);
        } else {
          this.jidu.rebate_swaq = 0;
        }

        // 基础季度返利（原逻辑）
        this.jidu.rebateBaseTotal = nc.add(
          this.jidu.rebate_ybw,
          this.jidu.rebate_ypw,
          this.jidu.rebate_swaq,
          this.jidu.rebate_ND5,
          this.jidu.rebate
        );
      }

      // 新增：超同期奖励（仅超低温&低温&冻干机）
      if (effectiveField === 'cdwdwdgj'
        && this.jidu.goal > this.jidu.tongqi
        && this.jidu.sales > this.jidu.tongqi
        && this.jidu.lvyue >= 0.8) {
        this.jidu.rebateSuperSamePeriod = nc.mul(this.jidu.base, 0.02);
      } else {
        this.jidu.rebateSuperSamePeriod = 0;
      }

      // 新增：等级加速奖励（仅药品网，且季度完成率>=100%）
      if (effectiveField === 'zhyl' && this.jidu.lvyue >= 1) {
        const level = Number(this.jidu.agentLevel);
        // 后端确认枚举：0=A，1=B，2=C，3=新开
        if (level === 0) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.04);
        } else if (level === 1) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.03);
        } else if (level === 2) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.01);
        } else if (level === 3) {
          this.jidu.rebateLevelAccelerate = nc.mul(this.jidu.base, 0.03);
        } else {
          this.jidu.rebateLevelAccelerate = 0;
        }
      } else {
        this.jidu.rebateLevelAccelerate = 0;
      }

      this.jidu.jiduRebate = nc.add(
        this.jidu.rebateBaseTotal,
        this.jidu.rebateSuperSamePeriod,
        this.jidu.rebateLevelAccelerate
      );
    },
    //测算日志记录
    rebateLog() {
      ss.fanli.rebateLog(this.fl.customerName, this.chooseRadio).then(rd => {
        console.log("返利测算结束")
      });
    },
    //当前登录人
    localAgent() {
      ss.fanli.localAgent().then(rd => {
        if (rd.obj) {
          this.fl.customerName = rd.obj;
        }
      });
    },
    getCustomerPage(value) {
      if (value !== '') {
        this.agentList = [];
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          ss.fanli.getCustomerPage(value).then(rd => {
            if (rd.obj) {
              this.agentList = rd.obj;
            } else {
              this.agentList = [];
            }
          })
        }, 200);
      } else {
        this.agentList = [];
      }

    },
    //选择经销商
    selectResult(value) {
      this.fl.customerName = value;
      this.noTarget = false;
      this.fl_cesuan = false;
      this.cs_yue = false;
      this.cs_jidu = false;
      this.cs_year = false;
      this.cs_yue_fl = this.cs_yue;
      this.chosenField = null;
      this.setRebateZero();
    },
    shengcheng() {
      //隐藏最后返利计算结果
      this.setResultFalse();
      this.fl_cesuan = false;
      this.cs_year = false;
      if (this.fl.customerName && this.fl.areaCode && this.fl.field) {
        // 本次测算锁定链群快照，后续表格展示与计算都以此为准
        this.chosenField = this.fl.field;
        if (this.radio == 1) {
          this.cs_yue = true;
          this.cs_jidu = false;
          this.cs_year = false;
          this.chooseRadio = 1;
        } else if (this.radio == 2) {
          this.cs_yue = true;
          this.cs_jidu = true;
          this.cs_year = false;
          this.chooseRadio = 2;
        } else if (this.radio == 3 && this.fl.field == 'cdwdwdgj') {
          this.cs_yue = false;
          this.cs_jidu = false;
          this.cs_year = true;
          this.chooseRadio = 3;
        } else if (this.radio == 3) {
          this.$msg.msge("仅超低温&低温&冻干机支持年度奖励测算");
          return;
        }
        this.cs_yue_fl = true;
        this.fl_cesuan = true;
        this.selectFlInfoByAgent();
      } else {
        this.$msg.msge("请先选择区域、经销商和领域");
        return;
      }
    },
    setRebateZero() {
      this.month.month1Rebate = 0;
      this.month.month1RebateFx = 0;
      this.month.month1RebateHj = 0;
      this.month.month2Rebate = 0;
      this.month.month2RebateFx = 0;
      this.month.month2RebateHj = 0;
      this.month.month3Rebate = 0;
      this.month.month3RebateFx = 0;
      this.month.month3RebateHj = 0;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.rebateBaseTotal = 0;
      this.jidu.rebateSuperSamePeriod = 0;
      this.jidu.rebateLevelAccelerate = 0;
      this.jidu.jiduRebate = 0;
      // 年度：点击“返利测算”时仅重算通算金额，不清空后台返回/前端输入值
      this.annual.totalAmount = 0;
      this.result_month = false;
      this.result_jidu = false;
      this.result_year = false;
    },
  },
  mounted() {
    if (sessionStorage.getItem("areaName")) {
      let areaName = sessionStorage.getItem("areaName")
      this.fl.areaCode = areaName.slice(0, -1)
      let cityListArr = this.$store.getters.dicts['YLRegion']
      let cityCode = cityListArr.filter((o) => o.name == this.fl.areaCode);
      this.fl.areaCode = cityCode[0].code || ''
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
}

.remark {
  padding-left: 2px;
  font-size: 12px;
  text-align: left;
}

.condition {
  font-size: 13px;
  text-align: center;
}

.h-head {
  font-size: 15px;
  text-align: center;
  font-weight: bold;
}

.h-text {
  font-size: 14px;
  text-align: center;
}

::v-deep .h-edit .el-input .el-input__inner {
  font-size: 13px;
  text-align: center;
  width: 100%;
  color: blue;
}

.h-result {
  font-size: 14px;
  text-align: center;
  color: blue;
}

::v-deep .h-count .el-input .el-input__inner {
  font-size: 14px;
  text-align: center;
}

/* 去掉Element UI的Input边框 */
::v-deep .leftdes .el-input__inner {
  border: none !important; /* 使用 !important 来确保覆盖默认样式 */
  box-shadow: none !important;
}

/* 如果你还想要去掉聚焦时的边框 */
::v-deep .leftdes.el-input__inner:focus {
  outline: none !important;
}
</style>
<style scoped lang="scss">

.message .h-formbLine .h-elformWrap-2 {
  width: 33.3333%;
}

.tan .h-formbLine .el-form-item__label {
  width: 47%;
}

.tan .h-formbLine .el-form-item__content {
  width: 53%
}

.tan .h-formbLine .h-elformWrap-2 {
  width: 50%;
}

.tan .h-elformWrap-1 .el-form-item__label {
  width: 20%;
}

.tan .h-elformWrap-1 .el-form-item__content {
  width: 80%;
}


$ft-colorg: #21d16f; //绿色的字
$ft-coloro: #e79118; //黄色的字
$bg-colorg: #f6fffa; //绿色的背景色
$bg-coloro: #fffbf7; //黄色的背景色
$bg-colorb: #3b77fc; //蓝色
$bg-colorgrey: #c3c3c3; //灰色
.yx_progressBar {
  margin: 0.28rem 0;
  width: 100%;
  border: 1px solid $ft-colorg;
  background-color: $bg-colorg;
  padding: 0.38rem;

  .yx_topTip {

    justify-content: flex-start;
    color: #424441;
    font-size: 0.18rem;

    .leftdes {
      margin-right: 0.75rem;
    }
  }
}
</style>